import { useQuery } from 'react-query';
import { type SessionPagesResponse } from '../dtos/SessionPagesDto';
import { logger, fetcher } from '../utils/Fetcher';
import { API_URLS } from '../utils/urls';

const useSessionProgramPages = () => {
  return useQuery('SessionProgramPages', async () => {
    try {
      const response = await fetcher.get<SessionPagesResponse>(API_URLS.PROGRAM_LIST);

      return response;
    } catch (error) {
      logger.error(error);
      throw error;
    }
  });
};

export default useSessionProgramPages;
